'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
var button = require('./button-c50f4784.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');

var StyledInfo = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  white-space: pre;\n"], ["\n  display: flex;\n  align-items: center;\n  white-space: pre;\n"])));
var Info = function (_a) {
    var total = _a.total, limit = _a.limit, offset = _a.offset, labels = _a.labels;
    var showingFrom = offset + 1;
    var showingTo = Math.min(showingFrom + limit - 1, total);
    return (React__default.createElement(StyledInfo, null,
        React__default.createElement("span", { "data-testid": "from" }, total ? showingFrom + " - " + showingTo : '1 ---'), " " + labels.of + " ",
        React__default.createElement("span", { "data-testid": "to" }, total || '---')));
};
var templateObject_1;

var FIRST_PAGE_INDEX = 1;
var Container = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 4px;\n"])));
var Controls = function (_a) {
    var page = _a.page, totalPages = _a.totalPages, setPage = _a.setPage;
    var isEmpty = totalPages === 0;
    var isFirstPage = page === FIRST_PAGE_INDEX || isEmpty;
    var isLastPage = page === totalPages || isEmpty;
    var setPageHandler = React.useCallback(function (index) { return function () { return setPage(index); }; }, [setPage]);
    return (React__default.createElement(Container, null,
        React__default.createElement(button.Button, { "data-testid": "pagination-chevron_left", variant: "Plain", Icon: React__default.createElement("span", { className: "material-icons-outlined" }, "chevron_left"), onClick: setPageHandler(page - 1), disabled: isFirstPage }),
        React__default.createElement(button.Button, { "data-testid": "pagination-chevron_right", variant: "Plain", Icon: React__default.createElement("span", { className: "material-icons-outlined" }, "chevron_right"), onClick: setPageHandler(page + 1), disabled: isLastPage })));
};
var templateObject_1$1;

var LIMIT = 50;
var PaginationRow = styled__default.div(templateObject_1$2 || (templateObject_1$2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n"])));
var PaginationV2 = function (_a) {
    var page = _a.page, setPage = _a.setPage, _b = _a.limit, limit = _b === void 0 ? LIMIT : _b, offset = _a.offset, total = _a.total, labels = _a.labels;
    var numberOfPages = Math.ceil(total / LIMIT);
    return (React__default.createElement(PaginationRow, { "data-testid": "pagination" },
        React__default.createElement(Info, { total: total, limit: limit, offset: offset, labels: labels }),
        React__default.createElement(Controls, { page: page, totalPages: numberOfPages, setPage: setPage })));
};
var templateObject_1$2;

exports.PaginationV2 = PaginationV2;
